var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,14.4c-0.7,0-1.5-0.3-2-0.8l-1.4-1.4c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l1.4,1.4 c0.4,0.4,1.2,0.2,1.7-0.3l5.2-5.2C17.9,6.3,18,6,18,5.6c0-0.4-0.1-0.7-0.4-1l-2.2-2.2c-0.5-0.5-1.5-0.5-2,0l-1.8,1.8 c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4L12,1c1.3-1.3,3.5-1.3,4.8,0L19,3.2c0.6,0.6,1,1.5,1,2.4c0,0.9-0.4,1.8-1,2.4l-5.2,5.2 C13,14,12.1,14.3,11.2,14.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,20C5.6,20,5.6,20,5.6,20c-0.9,0-1.8-0.4-2.4-1L1,16.8c-0.6-0.6-1-1.5-1-2.4c0-0.9,0.4-1.8,1-2.4l5.2-5.2 c1.3-1.3,3.4-1.5,4.5-0.3l1.4,1.4c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L9.3,7.8C9,7.5,8.2,7.6,7.7,8.1l-5.2,5.2 C2.1,13.7,2,14,2,14.4c0,0.4,0.1,0.7,0.4,1l2.2,2.2c0.3,0.3,0.6,0.4,1,0.4h0c0.4,0,0.7-0.1,1-0.4l1.8-1.8c0.4-0.4,1-0.4,1.4,0 c0.4,0.4,0.4,1,0,1.4L8,19C7.4,19.6,6.5,20,5.6,20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.407b04309bbf1101ed205776937234e6.svg";
export { ForwardRef as ReactComponent };